import React from 'react';
import { Guardian } from '@xaamin/guardian';
import { Button, ButtonGroup, Col, Row } from 'react-bootstrap';

const SelectionButton = (props) => {
  const { tipo, onChange, ...rest } = props;

  const handleOnChange = () => {
    onChange(tipo);
  }

  return (
    <Button
      { ...rest }
      onClick={ handleOnChange }
    >
      { tipo }
    </Button>
  );
}

const ComprobanteSelectionToolbar = (props) => {
  const { comprobante, onChange } = props;

  return (
    <>
      <Row>
        <Col className="overflow-auto pb-3">
          <ButtonGroup aria-label="Tipo de comprobante">
            { Guardian.allows('factura.crear.ingreso') && (
              <SelectionButton
                tipo="Ingreso"
                variant={ comprobante.isIngreso() ? 'primary' : 'secondary' }
                onChange={ onChange }
              />
            )}

            { Guardian.allows('factura.crear.egreso') && (
              <SelectionButton
                tipo="Egreso"
                variant={ comprobante.isEgreso() ? 'primary' : 'secondary' }
                onChange={ onChange }
              />
            )}

            { Guardian.allows('factura.crear.nomina') && (
              <SelectionButton
                tipo="Nomina"
                variant={ comprobante.isNomina() ? 'primary' : 'secondary' }
                onChange={ onChange }
              />
            )}

            { Guardian.allows('factura.crear.pago') && (
              <SelectionButton
                tipo="Pago"
                variant={ comprobante.isPago() ? 'primary' : 'secondary' }
                onChange={ onChange }
              />
            )}

            { Guardian.allows('factura.crear.traslado') && (
              <SelectionButton
                tipo="Traslado"
                variant={ comprobante.isTraslado() ? 'primary' : 'secondary' }
                onChange={ onChange }
              />
            )}
          </ButtonGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="pt-3 text-left">
            { comprobante.isIngreso() && (
                <p>
                  Se emiten por los ingresos que obtienen los contribuyentes, ejemplo: prestación de servicios, arrendamiento, honorarios, donativos recibidos, enajenación de bienes y mercancías, incluyendo la enajenación que se realiza en operaciones de comercio exterior, etc.
                </p>
              )
            }

            { comprobante.isEgreso() && (
                <p>
                  Amparan devoluciones, descuentos y bonificaciones para efectos de deducibilidad y también puede utilizarse para corregir o restar un comprobante de ingresos en cuanto a los montos que documenta, como la aplicación de anticipos. Este comprobante es conocido como nota de crédito.
                </p>
              )
            }

            { comprobante.isPago() && (
                <p>
                  Es un CFDI que incorpora un complemento para recepción de pagos, el cual debe emitirse en los casos de operaciones con pago en parcialidades o cuando al momento de expedir el CFDI no reciban el pago de la contraprestación y facilita la conciliación de las facturas contra pagos.
                </p>
              )
            }

            { comprobante.isTraslado() && (
                <p>
                  En el Comprobante de Traslado se declara la mercancía que se transporta de un lugar a otro, la emisión de este tipo de comprobante no supone un ingreso para el contribuyente. Solo se utiliza como requisito para que la autoridad avale de qué se trata de un traslado legal de mercancías.
                </p>
              )
            }
          </div>
        </Col>
      </Row>
    </>
  )
}

export default ComprobanteSelectionToolbar;
